import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import PrimaryButton from "./components/_utils/CommonButtons/PrimaryButton";
import { getRefreshTokenNew } from "./redux/features/refreshToken/refreshToken";
import ICONS from "./assets/Icons";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error(error);
    console.error(errorInfo);
  }

  handleClick = () => {
    window.location.href = "https://www.q2pay.in/landing/contact";
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="w-full min-h-screen flex justify-center items-center p-padding-md">
          <div className="w-full max-w-tab-width-normal bg-primary-nav rounded-border-radius-md p-padding-xl flex flex-col lg:flex-row items-center justify-center gap-gap-xl">
            <div className="flex justify-center items-center mb-margin-md lg:mb-margin-base">
              <img
                className=" h-graphic-rectangle-height-lg w-graphic-width-lg"
                src={ICONS?.UNKNOWN_ERROR}
                alt="oops"
              />
            </div>

            <div className="w-full lg:w-width-md flex flex-col justify-center items-center text-center">
              <div className="text-5xl text-text-primary mb-margin-md font-sans">
                Oops!
              </div>

              <div className="text-text-primary pb-padding-xl text-base">
                An unknown error has occurred,
                <br /> kindly retry the operation later.
              </div>

              <div className="text-text-secondary text-sm">
                If the problem still persists
                <br />
                contact &nbsp;
                <span
                  className="text-pending underline cursor-pointer"
                  onClick={this.handleClick}
                >
                  customer support
                </span>
              </div>

              <div className="flex flex-row justify-center items-center gap-gap-md w-full mt-margin-xl">
                <PrimaryButton
                  enabledBgColor=""
                  btnText="Try Again"
                  outLineColor="var(--text-primary)"
                  enabledTextColor="var(--text-primary)"
                  handleFunction={() => window.location.reload()}
                  hoverOption="white"
                />

                <HomeButton />
              </div>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export const HomeButton = () => {
  const handleHomeClick = () => {
    window.location.reload();
    window.location.href = "/home";
  };

  return (
    <>
      <PrimaryButton
        enabledBgColor="var(--text-primary)"
        btnText="Home"
        enabledTextColor="var(--primary-bg)"
        handleFunction={handleHomeClick}
        hoverOption="black"
      />
    </>
  );
};

function App() {
  const { conciergeLoading } = useSelector((state) => state.multientity);
  const [showModalPopup, setShowModalPopup] = useState(false);
  const { data } = useSelector((state) => state.refreshToken);
  const { showReloginModal } = useSelector((state) => state.login);
  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    const checkSession = async () => {
      const hasSessionExpired = window.sessionStorage.getItem("q2p_token");

      if (hasSessionExpired) {
        try {
          dispatch(getRefreshTokenNew());
        } catch (error) {
          setShowModalPopup(true);
        }
      }
    };
    checkSession();
  }, [dispatch, pathname, markerData]);

  useEffect(() => {
    if (data?.employees?.first_login_flag == "Y") {
      navigate("/setNewPassword");
    }
  }, [data]);

  const safePaths = new Set([
    "/login",
    "/",
    "/contactAdmin",
    "/product",
    "/pricing",
    "/aboutus",
    "/advisors",
    "/contactus",
    "/book_demo",
  ]);

  useEffect(() => {
    const tokenMissing = !sessionStorage.getItem("q2p_token");
    const isSafePath = safePaths.has(pathname);

    if (showReloginModal && !conciergeLoading && !isSafePath) {
      if (tokenMissing) {
        sessionStorage.removeItem("loggedIn");
      }

      // ✅ Store the first pathname only once
      if (!sessionStorage.getItem("previousLog")) {
        sessionStorage.setItem("previousLog", pathname);
      }

      navigate("/relogin", { replace: true });
    }
  }, [showReloginModal, conciergeLoading, navigate, pathname]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="App">
      <ErrorBoundary>
        <Outlet />
        <ToastContainer
          style={{ zIndex: "var(--max-zindex)" }}
          className="toast-container"
        />
      </ErrorBoundary>
    </div>
  );
}

export default App;
